import React from 'react';
import * as Icons from 'react-feather';

export default function Breadcrumb() {


    return (<>
        <div className="-intro-x breadcrumb breadcrumb--light ml-auto">
            <a href="">هاشور</a>
            <Icons.ChevronLeft className="breadcrumb__icon"/>
            <a href="" className="breadcrumb--active">داشبورد </a>
        </div>
    </>);
}